import React from "react";
import { CustomButton } from "./CustomButton";
import { ButtonProps } from "@mui/material";
import { ButtonsColorType } from "../../types/enums";
import { buttonColorMapper } from "../../types/genereal";

type Props = {
  buttonType?: ButtonsColorType;
} & ButtonProps;

export const GradientButton = ({
  children,
  buttonType = ButtonsColorType.gradient,
  ...props
}: Props) => {
  const { borderColor, customGradientColor } = buttonColorMapper[buttonType];
  return (
    <CustomButton
      customSize="fit"
      type="submit"
      customColor={borderColor}
      customGradientColor={customGradientColor}
      {...props}
    >
      {children}
    </CustomButton>
  );
};
